import React, { useEffect } from 'react'
import Switch from '#/components/Switch'
import cn from '#/utils/classnames'
import styles from '../styles.module.scss'

export type Period = 'annual' | 'monthly'
interface PeriodPickerProps {
  onlyYearly?: boolean
  period: Period
  onChange(interval: Period): void
}

export default function PeriodPicker({
  onlyYearly,
  period,
  onChange
}: PeriodPickerProps) {
  useEffect(() => {
    if (onlyYearly) onChange('annual')
  }, [onlyYearly])

  if (onlyYearly) {
    return <div className={styles['th-period-picker']} />
  }

  function handleChange(_: React.ChangeEvent, checked: boolean) {
    onChange(checked ? 'annual' : 'monthly')
  }

  return (
    <div className={styles['th-period-picker']}>
      <span
        className={cn(styles['th-period'], { [styles['th-selected']]: period === 'monthly' })}
        onClick={() => onChange('monthly')}
      >
        Bill Monthly
      </span>
      <Switch checked={period === 'annual'} onChange={handleChange} />
      <span
        className={cn(styles['th-period'], { [styles['th-selected']]: period === 'annual' })}
        onClick={() => onChange('annual')}
      >
        Bill Annually
        <span className={styles['th-badge']}>SAVE 18%</span>
      </span>
    </div>
  )
}
